// extracted by mini-css-extract-plugin
module.exports = {"main":"VideoSection_main__0pMNP","video-container":"VideoSection_video-container__MBSXj","body-text-container":"VideoSection_body-text-container__EyG_G"};